import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { api, setToken, getToken } from '../api';

export default function Login() {
  const nav = useNavigate();
  const [login, setLogin] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [busy, setBusy] = useState(false);

  // Already logged in? skip to app.
  React.useEffect(() => { if (getToken()) nav('/', { replace: true }); }, [nav]);

  async function submit(e) {
    e.preventDefault();
    setError(''); setBusy(true);
    try {
      const res = await api('/auth/login', { method: 'POST', body: { login, password } });
      setToken(res.token);
      nav('/', { replace: true });
    } catch (err) {
      setError(err.message || 'Login failed');
      setBusy(false);
    }
  }

  return (
    <div className="login-wrap">
      <form className="login-card" onSubmit={submit}>
        <div className="brand-mark">ADMPL<span className="dot">.</span></div>
        <div className="login-sub">Sign in to your management workspace</div>

        {error && <div className="login-error">{error}</div>}

        <div className="field">
          <label>Email or Employee ID</label>
          <input
            type="text" value={login} autoFocus autoComplete="username"
            onChange={(e) => setLogin(e.target.value)}
            placeholder="you@company.com"
          />
        </div>
        <div className="field">
          <label>Password</label>
          <input
            type="password" value={password} autoComplete="current-password"
            onChange={(e) => setPassword(e.target.value)}
            placeholder="••••••••"
          />
        </div>
        <button className="btn-primary" type="submit" disabled={busy || !login || !password}>
          {busy ? 'Signing in…' : 'Sign in'}
        </button>
      </form>
    </div>
  );
}
